/**
 * Subscription Banner
 * Visar information om demo/trial-status
 */

import { usePermissionsStore } from '@/store/permissionsStore';
import { ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';

export const SubscriptionBanner = () => {
  const { isDemo, isTrial, getTrialDaysRemaining } = usePermissionsStore();
  
  const isInDemo = isDemo();
  const isInTrial = isTrial();
  const daysRemaining = getTrialDaysRemaining();

  if (!isInDemo && !isInTrial) {
    return null;
  }

  if (isInDemo) {
    return (
      <div className="bg-amber-50 border-l-4 border-amber-400 p-3 mb-4">
        <div className="flex items-center">
          <InformationCircleIcon className="h-5 w-5 text-amber-400 mr-2" />
          <div>
            <p className="text-sm text-amber-700 font-medium">
              Demo-läge
            </p>
            <p className="text-xs text-amber-600">
              Du kör i demo-läge. Endast läsoperationer är tillgängliga.
              Kontakta oss för att uppgradera till full version.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (isInTrial && daysRemaining !== null) {
    const isUrgent = daysRemaining <= 3;
    const isWarning = daysRemaining <= 7;

    if (daysRemaining <= 0) {
      return (
        <div className="bg-red-50 border-l-4 border-red-400 p-3 mb-4">
          <div className="flex items-center">
            <ExclamationTriangleIcon className="h-5 w-5 text-red-400 mr-2" />
            <div>
              <p className="text-sm text-red-700 font-medium">
                Provperioden har gått ut
              </p>
              <p className="text-xs text-red-600">
                Din provperiod har gått ut. Kontakta oss för att fortsätta använda tjänsten.
              </p>
            </div>
          </div>
        </div>
      );
    }

    if (isUrgent || isWarning) {
      return (
        <div className={`${isUrgent ? 'bg-red-50 border-red-400' : 'bg-amber-50 border-amber-400'} border-l-4 p-3 mb-4`}>
          <div className="flex items-center">
            <ExclamationTriangleIcon className={`h-5 w-5 ${isUrgent ? 'text-red-400' : 'text-amber-400'} mr-2`} />
            <div>
              <p className={`text-sm font-medium ${isUrgent ? 'text-red-700' : 'text-amber-700'}`}>
                {daysRemaining === 1 ? '1 dag kvar' : `${daysRemaining} dagar kvar`} av provperioden
              </p>
              <p className={`text-xs ${isUrgent ? 'text-red-600' : 'text-amber-600'}`}>
                Din provperiod går ut snart. Kontakta oss för att uppgradera.
              </p>
            </div>
          </div>
        </div>
      );
    }
  }

  return null;
};

export default SubscriptionBanner;
